@if (isPlayer()) {
  <div  class="support-container">
    <button class="support-button" (click)="openSupportWindow()">
      <img src="../../../../assets/img/icon/support-black.png" alt="support" />
      <span>Contact Us</span>
    </button>
  </div>
}
